import { Box, Button, Grid, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import UploadFile from '../adHocTransactions/common/fileUpload'
import { PRIMARY_COLOR, SECONDARY_BACKGROUND_COLOR } from 'src/constants';
import { Add, RefreshOutlined, SaveAltOutlined, SimCardDownloadOutlined } from '@mui/icons-material';
import moment from 'moment';
import CommonAdHocTable from '../adHocTransactions/adHocTable/table';
import SimpleBackdrop from 'src/components/Backdrop';
import useAxios from 'src/hooks/useAxios';
import { getBulkTypeStatus, getPartnerUploadErrorDetails, getPartnerUploadHistory } from '../PartnerUpload/api';
import { PAGE_SIZE, GET_PARTNER_UPLOAD_HONDURAS, exportToExcel, BULK_UPLOAD_PARTNER_DATA } from '../PartnerUpload/constant';
import { FILE_ACTION, PARTNER_UPLOAD_TYPE } from '../adHocTransactions/constants';
import { getPreSignedUrlAPI } from '../adHocTransactions/apiActions';
import { downloadReport } from '../PaymentCalculations/VendorPayment/helper';
import useUploadFile from '../PartnerUpload/useUploadFile';
import { StyledLoadMoreBtn } from '../adHocTransactions/check';

const ManagePartners = () => {

  const API = useAxios();
  const [currentPage, setCurrentPage] = useState(0);
  const [uploadHistoryData, setUploadHistoryData] = useState<any>([]);
  const [createPartnerDownloadTemplateLink, setPospDownloadTemplateLink] = useState<any>();
  const [showLoader, setShowLoader] = useState(false);
  const axiosInstance = useAxios();
  const [uploadFile] = useUploadFile();

  useEffect(() => {
    fetchUploadStatusList();
    fetchUploadHistoryList();
  }, [])

  const fetchUploadStatusList = async () => {
    const response = await getBulkTypeStatus(axiosInstance);
    if (response?.data?.responseDTOList?.length) {
      const partnerUploadType: any = response?.data?.responseDTOList.filter(
        (elt) => elt.bulkUploadType === BULK_UPLOAD_PARTNER_DATA
      );
      if (partnerUploadType?.length) {
        setPospDownloadTemplateLink(partnerUploadType[0]?.bulkUploadTemplateURI);
      }
    }
  };

  const fetchUploadHistoryAfterUploadFile = async () => {
    setShowLoader(true);
    try {
      const response = await getPartnerUploadHistory(
        axiosInstance,
        0,
        BULK_UPLOAD_PARTNER_DATA,
        GET_PARTNER_UPLOAD_HONDURAS
      );
      if (response?.data?.length) {
        setUploadHistoryData(response?.data);
        setCurrentPage(1);
      } else {
        setUploadHistoryData([]);
      }
    } catch (err) {
      setUploadHistoryData([]);
      setShowLoader(false);
    } finally {
      setShowLoader(false);
    }
  };


  const fetchUploadHistoryList = async (page = currentPage) => {
    setShowLoader(true);
    try {
      const response = await getPartnerUploadHistory(
        axiosInstance,
        page,
        BULK_UPLOAD_PARTNER_DATA,
        GET_PARTNER_UPLOAD_HONDURAS
      );
      if (response?.data?.length) {
        setUploadHistoryData([...uploadHistoryData, ...response?.data]);
        setCurrentPage((page) => page + 1);
      }
    } catch (err) {
      setShowLoader(false);
    } finally {
      setShowLoader(false);
    }
  };

  const handleFileChange = (file) => {
    uploadFile(file, BULK_UPLOAD_PARTNER_DATA, fetchUploadHistoryAfterUploadFile, GET_PARTNER_UPLOAD_HONDURAS);
  };

  const fetchUploadErrorList = async (fileId, fileName) => {
    const response = await getPartnerUploadErrorDetails(
      axiosInstance,
      0,
      fileId
    );
    if (response?.data?.length) {
      exportToExcel(response?.data, fileName);
    }
  };

  const handleDownload = async (fileName, id) => {
    const body = {
      fileAction: FILE_ACTION.download,
      fileName: fileName,
      fileExtension: 'xlsx',
      partnerUploadType: PARTNER_UPLOAD_TYPE.posp,
      uploadId: id
    };
    const response = await getPreSignedUrlAPI(API, body);
    if (response?.data?.data?.preSignedUrl) {
      downloadReport(response?.data?.data?.preSignedUrl);
    }
  };

  const loadMoreData = () => {
    fetchUploadHistoryList();
  };

  const columns = [
    {
      field: 'fileName',
      headerName: 'File',
      flex: 3,
      renderCell: (params) => {
        return (
          <Box>
            <Button
              color="primary"
              size="medium"
              sx={{
                textTransform: 'capitalize',
                color: PRIMARY_COLOR,
                ':hover': {
                  background: '#f7f3ff',
                  border: 'none'
                }
              }}
              onClick={() =>
                handleDownload(params.row?.fileName, params.row?.id)
              }
              variant="text"
              startIcon={
                <SimCardDownloadOutlined
                  sx={{
                    color: 'rgba(0, 0, 0, 0.7)'
                  }}
                />
              }>
              {params?.row?.fileName}
            </Button>
            <Typography component={'span'} sx={{ color: 'rgba(0, 0, 0, 0.5)' }}>
              {`(${params?.row?.totalRowNumber} rows)`}
            </Typography>
          </Box>
        );
      }
    },
    { field: 'createdByActorName', headerName: 'Submitted By', flex: 1 },
    {
      field: 'createdOn',
      headerName: 'Submitted On',
      flex: 1,
      renderCell: (params) =>
        moment(params?.row?.createdOn).format('DD MMM YYYY hh:mm A')
    },
    { field: 'uploadStatus', headerName: 'Upload Status', flex: 1.6 },
    {
      field: 'errorRowNumber',
      headerName: 'Errors',
      flex: 1,
      renderCell: (params) => {
        if (params?.row?.uploadStatus === 'PARTNER_UPLOAD_COMPLETED') {
          return (
            <strong>
              <Button
                color="primary"
                sx={{
                  borderRadius: '10px',
                  textTransform: 'capitalize',
                  color:
                    params?.row?.errorRowNumber === 0
                      ? SECONDARY_BACKGROUND_COLOR
                      : PRIMARY_COLOR
                }}
                endIcon={<SaveAltOutlined />}
                size="small"
                onClick={() => {
                  if (params?.row?.errorRowNumber) {
                    fetchUploadErrorList(
                      params?.row?.id,
                      params?.row?.fileName
                    );
                  }
                }}>
                {params?.row?.errorRowNumber} rows
              </Button>
            </strong>
          );
        } else return '-';
      }
    }
  ];

  return (
    <Box marginTop="30px">
      <Grid container spacing={6}>
        <Grid item xs={6}>
          <Typography>To Create+Activate</Typography>
          <UploadFile marginBottom='0px' width='100%'
            handleFileChange={handleFileChange}
            downloadTemplateS3Link={createPartnerDownloadTemplateLink}
          />
        </Grid>
        <Grid item xs={6}>
          <Typography>To Deactivate or Reactviate</Typography>
          <UploadFile marginBottom='0px' width='100%'
            handleFileChange={handleFileChange}
            downloadTemplateS3Link={createPartnerDownloadTemplateLink}
          />
        </Grid>
      </Grid>

      <Box marginTop="20px"
        sx={{ fontWeight: 600, mb: 4, display: 'flex', alignItems: 'center' }}>
        <Typography>Upload History</Typography>
        <RefreshOutlined
          sx={{
            color: PRIMARY_COLOR,
            height: '24px',
            width: '24px',
            ml: 2,
            cursor: 'pointer'
          }}
          onClick={() => {
            fetchUploadHistoryAfterUploadFile();
          }}
        />
      </Box>

      <CommonAdHocTable
        getRowId={(row) => row.id}
        tableData={uploadHistoryData}
        columns={columns}
        rowHeight={50}
        cellContentPadding={0}
      />
      <StyledLoadMoreBtn
        startIcon={<Add />}
        variant="text"
        disabled={uploadHistoryData.length < currentPage * PAGE_SIZE}
        onClick={loadMoreData}>
        Load More
      </StyledLoadMoreBtn>
      {showLoader && <SimpleBackdrop open={showLoader} />}
    </Box>
  )
}

export default ManagePartners
